import * as React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Theme } from 'src/Theme';

interface ReturnButtonProps {
    label: string;
    to?: string;
    onClick?: () => void;
    sx?: Record<string, any>;
}

const ReturnButton: React.FC<ReturnButtonProps> = ({ label, to, onClick, sx = {} }) => {
    const defaultSx = {
        textTransform: 'none',
        color: Theme.palette.primary.grayBluish,
        fontSize: Theme.typography.body2.fontSize,
        ...sx
    };

    if (to) {
        return (
            <Button component={Link} to={to} startIcon={<KeyboardBackspaceIcon />} sx={defaultSx}>
                {label}
            </Button>
        );
    } else {
        return (
            <Button onClick={onClick} startIcon={<KeyboardBackspaceIcon />} sx={defaultSx}>
                {label}
            </Button>
        );
    }
};

export default ReturnButton;
